export default {
  all: 'All',
  // Action Buttons
  create: 'Create',
  edit: 'Edit',
  delete: 'Delete',
  save: 'Save',
  cancel: 'Cancel',
  confirm: 'Confirm',
  submit: 'Submit',
  failed: 'Failed',
  reset: 'Reset',
  search: 'Search',
  query: 'Query',
  clear: 'Clear',
  refresh: 'Refresh',
  export: 'Export',
  import: 'Import',
  upload: 'Upload',
  download: 'Download',
  view: 'View',
  back: 'Back',
  backToList: 'Back to List',
  next: 'Next',
  prev: 'Previous',
  close: 'Close',
  closeOthers: 'Close Others',
  closeRight: 'Close Right',
  closeAll: 'Close All',
  open: 'Open',
  expand: 'Expand',
  collapse: 'Collapse',
  copy: 'Copy',
  detail: 'Detail',
  more: 'More',
  cancelSelection: 'Cancel Selection',

  // Status
  statusLabel: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  enabled: 'Enabled',
  disabled: 'Disabled',
  normal: 'Normal',
  loading: 'Loading...',
  success: 'Success',
  error: 'Error',
  warning: 'Warning',
  info: 'Info',
  copySuccess: 'Copy Success',
  copyFailed: 'Copy Failed',

  // Time
  createTime: 'Create Time',
  updateTime: 'Update Time',
  lastLogin: 'Last Login',

  // Pagination
  total: 'Total',
  items: 'Items',
  page: 'Page',
  pageSize: 'Page Size',
  retry: 'Retry',
  to: 'to',

  // Others
  operation: 'Operation',
  actions: 'Actions',
  remark: 'Remark',
  description: 'Description',
  name: 'Name',
  code: 'Code',
  sort: 'Sort',
  yes: 'Yes',
  no: 'No',
  ok: 'OK',
  add: 'Add',
  noData: 'No Data',
  unknown: 'Unknown',
  notSpecified: 'Not Specified',
  scheme: 'Scheme',
  selectScheme: 'Select Scheme',
  saveAsScheme: 'Save as Scheme',
  defaultScheme: 'Default Scheme',
  selectAll: 'Select All',
  loadError: 'Load Failed',
  loadFailed: 'Load Failed',
  loadErrorDesc: 'Data failed to load. Please try again later or contact an administrator.',
  httpError: {
    unauthorized: 'Login expired, please login again',
    forbidden: 'Access denied',
    notFound: 'The requested resource does not exist',
    serverError: 'Server error, please try again later',
    requestFailed: 'Request failed'
  },
  resetDefault: 'Reset Default',
  saveAsFilterScheme: 'Save as Filter Scheme',
  pleaseEnterSchemeName: 'Please enter scheme name',
  savedSchemeWillAppearInDropdown: 'Saved scheme will appear in the dropdown',
  schemeSavedSuccessfully: 'Filter scheme saved successfully',
  schemeManagement: 'Scheme Management',
  schemeManagementDesc: 'Manage your filter schemes, double-click scheme name to edit quickly',
  schemeName: 'Scheme Name',
  isDefault: 'Is Default',
  setAsDefault: 'Set as Default',
  systemDefault: 'System Default',
  schemeNameCannotBeEmpty: 'Scheme name cannot be empty',
  schemeNameModifiedSuccessfully: 'Scheme name modified successfully',
  defaultSchemeSetSuccessfully: 'Default scheme set successfully',
  systemDefaultSchemeCannotBeDeleted: 'System default scheme cannot be deleted',
  currentDefaultSchemeCannotBeDeleted: 'Current default scheme cannot be deleted',
  schemeDeletedSuccessfully: 'Scheme deleted successfully',
  usageInstructions: 'Usage Instructions',
  doubleClickToEdit: 'Double-click scheme name to edit directly (except system default scheme)',
  onlyOneDefaultScheme: 'Only one default scheme allowed',
  systemAndCurrentDefaultCannotBeDeleted: 'System default scheme and current default scheme cannot be deleted',
  clickSetDefaultToChange: 'Click "Set as Default" to change default scheme',
  pleaseSelect: 'Please select',
  selectPlaceholder: 'Please select',
  pleaseInput: 'Please input',

  // Filter Scheme Management Related
  schemeManage: {
    default: 'Default',
    schemeUpdateSuccess: 'Scheme updated successfully',
    schemeUpdateError: 'Failed to update scheme',
    schemeSaveSuccess: 'Scheme saved successfully',
    schemeSaveError: 'Failed to save scheme',
    schemeNameCannotBeEmpty: 'Scheme name cannot be empty',
    systemSchemeCannotEdit: 'System default scheme cannot be edited',
    schemeNameUpdateSuccess: 'Scheme name updated successfully',
    schemeNameUpdateError: 'Failed to update scheme name',
    systemSchemeNoNeedSet: 'System default scheme does not need to be set',
    schemeNotFound: 'Scheme not found',
    defaultSchemeSetSuccess: 'Default scheme set successfully',
    defaultSchemeSetError: 'Failed to set default scheme',
    systemSchemeCannotDelete: 'System default scheme cannot be deleted',
    currentDefaultCannotDelete: 'Current default scheme cannot be deleted',
    schemeDeleteSuccess: 'Scheme deleted successfully',
    schemeDeleteError: 'Failed to delete scheme',
    dataLoadError: 'Data loading failed, please retry manually',
    customFilterScheme: 'Custom filter scheme: {name}'
  },

  // Filter Related
  filter: {
    title: 'Filter Conditions',
    equal: 'Equal',
    notEqual: 'Not Equal',
    contains: 'Contains',
    notContains: 'Not Contains',
    isEmpty: 'Is Empty',
    isNotEmpty: 'Is Not Empty',
    batch: 'Batch',
    addRemoveConditions: 'Add/Remove Conditions',
    fieldSettings: 'Filter Field Settings',
    autoDetect: '(Auto Detect)',
    selected: 'Selected',
    fields: 'fields',
    pleaseSelect: 'Please select',
    pleaseSelectMultiple: 'Please select multiple',
    pleaseInput: 'Please input',
    pleaseInputMultiple: 'Please input multiple',
    dateRangeStart: 'Start date',
    dateRangeEnd: 'End date',
    configLoadSuccess: 'Configuration loaded successfully',
    configLoadError: 'Failed to load configuration',
    schemeLoadError: 'Failed to load schemes',
    filterConfigNotFound: 'Filter configuration not found',
    useNewEnumSystem: 'Using new enum system to get options'
  },

  // Query Operators
  queryOperator: {
    eq: 'Equal',
    ne: 'Not Equal',
    like: 'Like',
    not_like: 'Not Like',
    in: 'In',
    not_in: 'Not In',
    is_null: 'Is Null',
    is_not_null: 'Is Not Null',
    gt: 'Greater Than',
    ge: 'Greater Than or Equal',
    lt: 'Less Than',
    le: 'Less Than or Equal',
    between: 'Between',
    not_between: 'Not Between',
    date_shortcut: 'Date Shortcut'
  },

  // Date Shortcuts
  dateShortcut: {
    this_week: 'This Week',
    last_week: 'Last Week',
    next_week: 'Next Week',
    this_month: 'This Month',
    last_month: 'Last Month',
    next_month: 'Next Month',
    this_year: 'This Year',
    last_year: 'Last Year',
    next_year: 'Next Year',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    last_7_days: 'Last 7 Days',
    last_30_days: 'Last 30 Days',
    last_90_days: 'Last 90 Days'
  },

  // Language Settings
  language: {
    current: 'Current Language',
    switch: 'Switch Language',
    chinese: '简体中文',
    english: 'English',
    switchSuccess: 'Language switched successfully',
    switchError: 'Failed to switch language'
  },

  // Theme Settings
  theme: {
    light: 'Light Theme',
    dark: 'Dark Theme',
    auto: 'Follow System'
  },

  // 仪表盘相关
  totalOrders: 'Total Orders',
  pendingOrders: 'Pending',
  inProgressOrders: 'In Progress',
  completedOrders: 'Completed',
  closedOrders: 'Closed',
  compareLastWeek: 'vs Last Week',
  compareYesterday: 'vs Yesterday',
  onTimeRate: 'On-time Rate',
  satisfaction: 'Satisfaction',
  closeRate: 'Close Rate',
  orderTracking: 'Order Tracking',
  businessNodes: 'Business Nodes',
  shippingNodes: 'Shipping Nodes',
  todoTasks: 'Todo Tasks',
  pendingOrdersLabel: 'Pending Orders',
  ordersUnit: 'orders',
  tasksLabel: 'Tasks',
  totalCountLabel: 'Total {count} orders to process',
  searchPlaceholder: 'Enter Order No./Quote No./Job No./MBL No./HBL No.',

  // 业务节点状态
  generateOrder: 'Generate Order',
  pricing: 'Pricing',
  booking: 'Booking',
  trucking: 'Trucking',
  warehouse: 'Warehouse',
  customs: 'Customs',
  vgm: 'VGM',
  blSupplement: 'B/L Supplement',
  bill: 'Bill',
  invoice: 'Invoice',
  paymentSlip: 'Payment Slip',
  billOfLading: 'Bill of Lading',

  // 节点状态
  nodeCompleted: 'Completed',
  quoted: 'Quoted',
  spaceConfirmed: 'Space Confirmed',
  loaded: 'Loaded',
  inWarehouse: 'In Warehouse',
  customsCleared: 'Customs Cleared',
  pendingSubmit: 'Pending Submit',
  pendingGenerate: 'Pending Generate',
  pendingInvoice: 'Pending Invoice',
  pendingUpload: 'Pending Upload',
  pendingSign: 'Pending Sign',
  inProgress: 'In Progress',
  pendingStart: 'Pending Start',

  // Test Component Related
  test: {
    component: 'Test Component',
    content: 'Test Content',
    data: 'Test Data',
    componentName: 'Component Name',
    createTime: 'Create Time',
    status: 'Status',
    version: 'Version',
    customContent: 'Custom Content'
  },

  // Action Operations
  action: {
    refresh: 'Refresh',
    expand: 'Expand',
    collapse: 'Collapse',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit'
  },

  // Status Extended
  status: {
    active: 'Active',
    inactive: 'Inactive',
    expanded: 'Expanded',
    collapsed: 'Collapsed'
  },

  // Table Related
  table: {
    name: 'Name',
    type: 'Type',
    status: 'Status',
    createTime: 'Create Time',
    action: 'Action',
    data: 'Table Data',
    customTable: 'Custom Table',
    customTableSettings: 'Custom Table Settings',
    exportAsExcel: 'Export as Excel',
    exportAsCsv: 'Export as CSV',
    fieldsSelected: 'Selected {selected}/{total} fields',
    tableConfigSaveSuccess: 'Table configuration saved successfully',
    tableConfigLoadError: 'Failed to load table configuration',
    tableConfigSaveError: 'Failed to save table configuration',
    resetToDefaultSuccess: 'Reset to default successfully',
    exportSuccess: '{type} export successful',
    exportError: '{type} export failed'
  },
  columnScheme: {
    selectPlaceholder: 'Select column scheme',
    save: 'Save column scheme',
    saveTitle: 'Save table column scheme',
    name: 'Scheme name',
    namePlaceholder: 'Enter column scheme name',
    nameRequired: 'Please enter a column scheme name',
    noColumns: 'There are no column settings to save',
    saveSuccess: 'Column scheme saved successfully',
    saveError: 'Failed to save column scheme'
  },

  // Confirmation Messages
  confirmMessages: {
    delete: 'Are you sure you want to delete this record?',
    logout: 'Confirm Logout',
    logoutMessage: 'Are you sure you want to logout?'
  },

  // Message Notifications
  message: {
    refreshSuccess: 'Refresh successful',
    actionSuccess: 'Operation successful',
    deleteSuccess: 'Delete successful',
    developmentInProgress: 'Feature under development...',
    logoutSuccess: 'Logout successful',
    logoutError: 'Logout failed',
    menuSearch: 'Please enter the menu name to search',
    pleaseCompleteRequiredFields: 'Please complete required fields'
  },

  // User Related
  user: {
    admin: 'Administrator',
    profile: 'Profile',
    settings: 'Account Settings',
    help: 'Help Center',
    logout: 'Logout',
    user: 'User'
  },

  // Menu Titles
  menu: {
    home: 'Home',
    dashboard: 'Dashboard',
    entrustedOrder: 'Booking Order',
    controlTowerPanel: 'Control Tower Panel',
    superRates: 'Super Freight Rate',
    rateManagement: 'Rate Management',
    fclRates: 'FCL Rates',
    contractManagement: 'Contract Management',
    surchargeManagement: 'Surcharge Maintenance',
    pricingRuleManagement: 'Pricing Rules',
    markupRuleMaintenance: 'Markup Rule Maintenance',
    businessMarkupRules: 'Business Markup Rules',
    salesMarkupRuleMaintenance: 'Sales Markup Rule Maintenance',
    salesQuotation: 'Sales Quotation',
    managementFreight: 'Management Freight',
    rateWarehouse: 'Rate Warehouse',
    rateWarehouseFcl: 'FCL Rate Warehouse',
    rateWarehouseLcl: 'LCL Rate Warehouse',
    rateQuery: 'Freight Rate Inquiry',
    ecommerceCarrierRates: 'Carrier E-commerce Rates',
    ecommerceRates: 'E-commerce Rates',
    ecommercePriceWatch: 'Rate Monitor',
    ecommercePlatformAccount: 'Account Management',
    ecommerceDailyRates: 'Daily Rates',
    ecommerceSubscription: 'Push Config',
    biddingManagement: 'Tendering & Bidding Management',
    tenderManagement: 'Tender Management',
    bidManagement: 'Bid Management',
    inquiryQuotation: 'Inquiry & Quotation',
    inquiryManagement: 'Inquiries',
    quoteManagement: 'Quotes',
    spaceQuery: 'Space Query',
    spaceBooking: 'Space Booking',
    spaceStatistics: 'Space Statistics',
    orders: 'Order Center',
    orderManagement: 'Order Management',
    orderTracking: 'Tracking',
    distributionShipment: 'Distribution Shipment',
    settlement: 'Settlement',
    settlementStatement: 'Settlement Invoice',
    waybill: 'Waybill',
    customer: 'Customer & Vendor Center',
    userManagement: 'User Management',
    companyManagement: 'Enterprise Management',
    addCompany: 'Add Company',
    editCompany: 'Edit Company',
    userCenter: 'User Center',
    roleAuthManagement: 'Role & Permission Management',
    userProfile: 'Personal Information',
    companyProfile: 'Company Information',
    billingManagement: 'Billing',
    application: 'Application Center',
    apiCenter: 'API Center',
    apiList: 'API List',
    apiSettings: 'API Settings',
    systemSettings: 'System Settings',
    roleManagement: 'Roles',
    staffManagement: 'Employee Management',
    permissionManagement: 'Permission Management',
    departmentManagement: 'Departments',
    postManagement: 'Posts',
    basicData: 'Master Data Maintenance',
    portManagement: 'Port Management',
    carrierManagement: 'Carrier Management',
    countryRegionManagement: 'Country(Region)',
    chinaAdministrativeDivision: 'Administrative Division',
    overseasWarehouseManagement: 'Warehouse Management',
    zipcodeManagement: 'Postal Code Management',
    routeManagement: 'Trade Lane Management',
    containerManagement: 'Container Management',
    packageUnitManagement: 'Packing Unit',
    transportTermsManagement: 'Transport Terms',
    tradeTermsManagement: 'Incoterms',
    currencyManagement: 'Currency Management',
    exchangeRateManagement: 'Exchange Rate Settings',
    calculationUnitManagement: 'Billing Unit',
    chargeManagement: 'Cost Management',
    shipAgentManagement: 'Shipping Agent Management',
    terminalManagement: 'Terminal Management',
    productMaterialData: 'Product Material Data',
    shipData: 'Vessel Data',
    componentsDemo: 'Components Demo',
    examplePage: 'Example Page',
    advancedSelectExample: 'Advanced Select Component',
    filterManagement: 'Filter Management',
    permissionUsage: 'Permission Usage',
    shipDataManagement: 'Ship Data Management',
    shippingScheduleCenter: 'Sailing Schedule Center',
    lineMaintenance: 'Trade Lane Maintenance',
    shipSchedule: 'Sailing Schedule Inquiry',
    personalizationConfig: 'Personalization Settings',
    companyNews: 'Company News',
    templateConfig: 'Template Settings',
    configManagement: 'Configuration Management',
    taskManagement: 'Task Management',
    nodeManagement: 'Node Management',
    businessManagerConfig: 'Operation Owner Settings',
    supplierQuotationConfig: 'Supplier Quotation Config'
  },

  // View Mode
  viewMode: {
    list: 'List View',
    card: 'Card View'
  },

  // System Related
  system: {
    name: 'Control Tower System',
    brand: 'CargoONE',
    mode: 'Operations',
    aiAssistant: 'AI Assistant',
    backToPortal: 'Back to Portal'
  },

  viewDetail: 'View Detail',
  weekdaySeparator: ', ',
  dayUnit: ' days',
  weekdays: {
    short: {
      1: 'Mon',
      2: 'Tue',
      3: 'Wed',
      4: 'Thu',
      5: 'Fri',
      6: 'Sat',
      7: 'Sun'
    }
  }
}
